const Portfolio_data = [
  {
    id: 1,
    category: "Pickwickczycy",
    totalLike: "I",
    title:
      "Pierwsze promienie światła, które rozjaśniły grube ciemności  towarzyszące ukazaniu się nieśmiertelnego Pickwicka na horyzoncie uczonego świata, jak też pierwszą urzędowąwzmiankę   o tym niepospolitym mężu, znajdujemy w protokołach Klubu Pickwicka.",
    image: "/assets/16.jpg",
  },
  {
    id: 2,
    category:
      "Pierwszy dzień podróży i pierwszy wieczór przygód z ich skutkami",
    totalLike: "II",
    title:
      "Słońce, ten punktualny sługa pracy, zaledwie wstało i rzuciło światło na poranek trzynastego maja 1827 roku, gdy pan Pickwick, podobny do drugiego słońca, wyrwał się z objęć snu; otworzył okno i spojrzał na świat. ",
    image: "/assets/8.jpg",
  },
  {
    id: 3,
    category:
      "Nowa znajomość - Opowieść włóczęgi - Niemiła przeszkoda - Przykre spotkanie",
    totalLike: "III",
    title:
      "Pan Pickwick doznawał pewnego niepokoju z powodu za długiej nieco nieobecności dwóch swoich przyjaciół, przypomniawszy sobie zwłaszcza niepojęte ich ranne zachowanie się.",
    image: "/assets/9.jpg",
  },
  {
    id: 4,
    category: "Mała wojna - Nowi znajomi - Zaproszenie na wieś",
    totalLike: "IV",
    title:
      "Wielu autorów upiera się przy zasadzie nie tylko głupiej, ale właściwie nieuczciwej, żeby nie podawać źródeł, z których czerpią najważniejsze informacje. Nie podzielamy tych zasad. Będziemy starali się jedynie o to, by wywiązać się w sposób właściwy z obowiązków, jakie nakłada na nas nasz zawód wydawcy.",
    image: "/assets/10.jpg",
  },
  {
    id: 5,
    category:
      "Zawierający między innymi opis, jak to pan Pickwick podjął się powożenia, a pan Winkle jazdy konnej, i jak się obaj z tego wywiązali",
    totalLike: "V",
    title:
      "Niebo było jasne i spokojne, powietrze balsamiczne, a wszystko  jakby oblane niewysłowionym urokiem. Pan Pickwick, wsparty na   poręczy mostu w Rochester, przypatrywał się krajobrazom w oczekiwaniu śniadania.",
    image: "/assets/11.jpg",
  },
  {
    id: 6,
    category: "Jak za dawnych czasów przepędzano wieczór na wsi",
    totalLike: "VI",
    title:
      "- Wiersz wikarego - Powrót skazańca Liczni goście zgromadzeni w salonie powstali dla przywitania nowo przybyłych. Gdy odbywały   się ceremonialne formalności przyjęcia, pan Pickwick miał czas   obejrzeć zebranych i poczynić wnioski co do ich charakterów i zajęć.",
    image: "/assets/12.jpg",
  },
];
export default Portfolio_data;
